/** @jsxImportSource @emotion/react */
import { optionCSS } from "@/app/components/form-fields/select/styling";
import { MenuContext } from "@/app/components/form-fields/select/WithMenu";
import { css } from "@emotion/react";
import { useFloatingTree, useListItem, useMergeRefs } from "@floating-ui/react";
import * as React from "react";

interface MenuItemProps {
  label: string;
  disabled?: boolean;
}

export const MenuItem = React.forwardRef<
  HTMLButtonElement,
  MenuItemProps & React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ label, disabled, ...props }, forwardedRef) => {
  const menu = React.useContext(MenuContext);
  const item = useListItem({ label: disabled ? null : label });
  const tree = useFloatingTree();
  const isActive = item.index === menu.activeIndex;

  return (
    <button
      {...props}
      ref={useMergeRefs([item.ref, forwardedRef])}
      type="button"
      role="menuitem"
      tabIndex={isActive ? 0 : -1}
      disabled={disabled}
      css={css(optionCSS(false, isActive, false))}
      {...menu.getItemProps({
        onClick(event: React.MouseEvent<HTMLButtonElement>) {
          props.onClick?.(event);
          tree?.events.emit("click");
        },
        onFocus(event: React.FocusEvent<HTMLButtonElement>) {
          props.onFocus?.(event);
          menu.setHasFocusInside(true);
        },
      })}
    >
      <div className="flex justify-between w-full">{label}</div>
    </button>
  );
});
